import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MenuList from './MenuList';
import MenuEditor from './MenuEditor';

const Menus = () => (
  <Routes>
    <Route index element={<MenuList />} />
    <Route path=":uuid" element={<MenuEditor />} />
  </Routes>
);

export default Menus;
